import React, { useState } from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    InputAdornment,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { Search } from '@mui/icons-material';
import _debounce from 'lodash.debounce';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';

import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import VisibilityIcon from '@mui/icons-material/Visibility';
import EditNoteIcon from '@mui/icons-material/EditNote';
import Badge from '@mui/material/Badge';
import axios from "axios";
import swal from "sweetalert";
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


import { useHistory } from "react-router-dom";
import Input from '@mui/material/Input';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';

import PhotoCamera from '@mui/icons-material/PhotoCamera';
import Stack from '@mui/material/Stack';
import AttachmentIcon from '@mui/icons-material/Attachment';
import Grid from '@mui/material/Grid';
import { useEffect } from 'react';
import { CSVLink } from 'react-csv';
import FileDownloadIcon from '@mui/icons-material/FileDownload';



const ShowSingleWorkShopCoupon = (props) => {
    const id = props.match.params.id;
    const history = useHistory();
    const eventName = localStorage.getItem('eventname');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchText, setSearchText] = useState('');
    const [customFieldList, setCustomFieldList] = React.useState([]);
    const [permissions, setrPermissions] = useState([]);
    const eventid = localStorage.getItem('eventid')
    const [showWorkShopCoupon, setShowWorkShopCoupon] = useState({});
    const [showMore, setShowMore] = useState(false);
    type StyleType = {
        position: string;
        top: string;
        left: string;
        transform: string;
        width: number;
        bgcolor: string;
        border: string;
        boxShadow: number;
        p: number;
    };

    const style: StyleType = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };
    useEffect(() => {
        axios.get(`api/workshop-coupon-show/${id}`).then((res) => {
            if (res.status == 200) {
                const wrkshpc = res.data.wce;
                setShowWorkShopCoupon(wrkshpc);

            }
        })
    }, [id]);


    React.useEffect(() => {
        axios.get(`api/getpermissionByRole`).then(res => {

            if (res.status === 200) {
                const datad = res.data.data.permissions;
                setrPermissions(datad)
            } else {

            }
        })

    }, []);

    const displayedCouponCodes = showWorkShopCoupon.coupon_codes ? showWorkShopCoupon.coupon_codes.slice(0, showMore ? undefined : 5) : [];
    const csvData = [
        ['Workshop Coupon Name', 'Workshop', 'Workshop Coupon Qty', 'Coupon Expire Date', 'Coupon Code'],
        [
            showWorkShopCoupon.workshop_coupon_name,
            showWorkShopCoupon.work_shops ? showWorkShopCoupon.work_shops.workshop_name : 'N/A',
            showWorkShopCoupon.workshop_coupon_qty,
            showWorkShopCoupon.coupon_expire_date,
            '', // Placeholder for Coupon Code column
        ],
        ...displayedCouponCodes.map((row) => [
            '', // Empty cells for other columns
            '', // Add workshop name to each row
            '',
            '',
            row.coupon_code,
        ]),
    ];

    const headers = [
        { label: 'Coupon Code', key: 'CouponCode' },
        // Add other headers as needed
    ];

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [recipientEmail, setRecipientEmail] = useState('');
    const [buttonClicked, setButtonClicked] = useState(false);


    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

  
    const sendEmail = async () => {
   
        try {
            const response = await axios.post(`/api/workshop-coupon-send-email/${eventid}`, {
                to: recipientEmail,
                subject: 'Your email subject',
                body: 'Your email body',
                attachment: csvData,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
             setButtonClicked(true);
    
            if (response.status === 200) {
                setRecipientEmail('');
               
               
                console.log('Email sent successfully!');
               
            } else {
                console.error('Failed to send email.');
            }
        } catch (error) {
            console.error('Error sending email:', error);
        }
    
        // Close the modal after sending the email
        closeModal();
    };
    
    const handlePrint = () => {
        // Create a printable HTML content based on csvData
        const printableContent = `
            <html>
                <head>
                    <title>${showWorkShopCoupon.workshop_coupon_name} Coupon Codes</title>
                    <style>
                        @media print {
                            body {
                                font-family: 'Arial', sans-serif;
                            }
                        }
                    </style>
                </head>
                <body>
                    <h2>Coupon Codes</h2>
                    <table border="1">
                        <thead>
                            
                        </thead>
                        <tbody>
                            ${csvData.map((row, rowIndex) => `<tr>${row.map((cell, cellIndex) => `<td>${cell}</td>`).join('')} `).join('')}
                        </tbody>
                    </table>
                </body>
            </html>
        `;

        // Open a new window for printing
        const printWindow = window.open('', '_blank');

        // Write the content to be printed
        printWindow.document.write(printableContent);

        // Close the print window after printing
        printWindow.onafterprint = () => {
            printWindow.close();
        };

        // Trigger the print dialog
        printWindow.print();
    };

    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })

    }, [eventid]);



    let backGroundButtonByEvent = "";
    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
    }
    //backgroundColor: backGroundButtonByEvent,

    return (
        <div style={{ margin: '1%', width: '100vw', marginLeft: '0%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>

                <Card sx={{ width: '82vw', float: 'center' }} >
                    <CardContent >
                        <h4 sx={{ m: 2, color: '#000000' }} >
                            Single WorkShop coupon
                            <Button sx={{
                                float: 'right',
                                marginTop: '2%',
                                backgroundColor: backGroundButtonByEvent,
                                ":hover": {
                                    color: "white"
                                }
                            }}
                                color='success'
                                size='small'
                                variant='contained'
                                component={Link}
                                //onClick={() => history.goBack()}
                                to={`/admin/workshop/manage-coupon`}
                                >
                                Back
                            </Button>

                        </h4>
                        <Box component="form" noValidate sx={{ mt: 3 }}>

                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell > #</TableCell>
                                            <TableCell align="left">Company Name</TableCell>
                                            <TableCell align="left">WorkShop</TableCell>
                                            <TableCell align="left"> Coupon Quanitiy</TableCell>
                                            <TableCell align="left">Expire Date</TableCell>
                                            <TableCell align="left">Coupon</TableCell>
                                            <TableCell align="center">Action</TableCell>


                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        <TableRow>
                                            <>
                                                <TableCell>1</TableCell>
                                                <TableCell>{showWorkShopCoupon.workshop_coupon_name}</TableCell>
                                                <TableCell>{showWorkShopCoupon.work_shops ? showWorkShopCoupon.work_shops.workshop_name : 'N/A'}</TableCell>
                                                <TableCell>{showWorkShopCoupon.workshop_coupon_qty}</TableCell>
                                                <TableCell>{showWorkShopCoupon.coupon_expire_date}</TableCell>
                                                <TableCell>
                                                    {displayedCouponCodes.length > 0 ? (
                                                        <>
                                                            <ul>
                                                                {displayedCouponCodes.map((row, i) => (
                                                                    <React.Fragment key={row.id}>
                                                                        <li>{row.coupon_code}</li>
                                                                    </React.Fragment>
                                                                ))}
                                                            </ul>
                                                            {showWorkShopCoupon.coupon_codes.length > 5 && (
                                                                <button onClick={() => setShowMore(!showMore)}>
                                                                    {showMore ? 'See Less' : 'See More'}
                                                                </button>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <span>No coupon codes available</span>
                                                    )}
                                                </TableCell>
                                                <TableCell>
                                                    {csvData.length > 0 && (
                                                        <>

                                                        {
                                                            permissions['p_workshop-coupons-export'] === true ?

                                                            <CSVLink data={csvData} filename={`${showWorkShopCoupon.workshop_coupon_name} Coupons.csv`}>  <Button sx={{
                                                                float: 'right',
                                                                marginRight: '1%',
                                                                marginTop: '2%',
                                                                backgroundColor: backGroundButtonByEvent,
                                                                ":hover": {
                                                                    color: "white"
                                                                }
                                                            }}
                                                                color='success'
                                                                size='small'
                                                                variant='contained' >
                                                                <FileDownloadIcon />&nbsp;&nbsp; Export In Excel
                                                            </Button></CSVLink> : ""}&nbsp;&nbsp;&nbsp;&nbsp;
                                                           
                                                            {
                                                            permissions['p_workshop-coupons-send-email'] === true ?
                                                            <Button onClick={openModal}
                                                                sx={{
                                                                    float: 'right',
                                                                    marginRight: '1%',
                                                                    marginTop: '2%',
                                                                    backgroundColor: backGroundButtonByEvent,
                                                                    ":hover": {
                                                                        color: "white"
                                                                    }
                                                                }}
                                                                color='success'
                                                                size='small'
                                                                variant='contained' >Send Email</Button>
                                                                :""}
                                                                {
                                                            permissions['p_workshop-coupons-print'] === true ?
                                                            <Button
                                                                sx={{
                                                                    float: 'right',
                                                                    marginRight: '1%',
                                                                    marginTop: '2%',
                                                                    backgroundColor: backGroundButtonByEvent,
                                                                    ':hover': {
                                                                        color: 'white',
                                                                    },
                                                                }}
                                                                color="success"
                                                                size="small"
                                                                variant="contained"
                                                                onClick={handlePrint}
                                                            >
                                                                Print
                                                            </Button>
                                                            :""}
                                                        </>
                                                    )}
                                                </TableCell>
                                                </>
                                        </TableRow>

                                    </TableBody>
                                </Table>

                            </TableContainer>

                        </Box>
                    </CardContent>
                </Card>
            </Box>
            <Dialog open={isModalOpen} onClose={closeModal} style={style}>
                <DialogContent>
                    <h2>Enter Recipient Email</h2>
                    <input
                        type="email"
                        placeholder="Recipient Email"
                        value={recipientEmail}
                        onChange={(e) => setRecipientEmail(e.target.value)}/>
                    {!buttonClicked && <button onClick={sendEmail}>Send Email</button>}
                    <button onClick={closeModal}>Cancel</button>
                </DialogContent>
            </Dialog>
        </div>
    );
}


export default ShowSingleWorkShopCoupon;
